/**
 * Social integration schemas — OAuth connection status per platform.
 */
import { z } from "zod";
export const SOCIAL_PLATFORMS = ["meta", "instagram", "linkedin", "twitter"];
export const SocialIntegrationStatusSchema = z.object({
    platform: z.enum(SOCIAL_PLATFORMS),
    connected: z.boolean(),
    // Whether a usable publish TARGET exists (e.g. a Facebook Page token), not just an
    // account token. "connected" can be true while this is false — Settings status must
    // match whether a publish will actually succeed (#137).
    can_publish: z.boolean(),
    // Human-readable caveat for a connected-but-limited state (no Page found, IG not
    // linked, LinkedIn personal-profile-only), or null when fully publish-ready.
    warning: z.string().nullable(),
    account_name: z.string().nullable(),
    connected_at: z.string().datetime().nullable(),
});
/** GET /settings/integrations */
export const IntegrationsListResponseSchema = z.object({
    integrations: z.array(SocialIntegrationStatusSchema),
});
/** POST /settings/integrations/:platform/connect response */
export const IntegrationConnectResponseSchema = z.object({
    auth_url: z.string().url(),
});
//# sourceMappingURL=integrations.js.map